var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GTreeView',{attrs:{"placeholder":"Rechercher un client","multiple":false,"load-options":_vm.loadUsers,"async":true},on:{"update:selected":function (data) { return _vm.$emit('selection', data); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }